import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../context/auth";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { PieChart, Pie, Cell, Legend } from "recharts";

const Carouseluser = () => {
    const [formTypesCount, setFormTypesCount] = useState({});
    const [filteredApplications, setFilteredApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [statusCounts, setStatusCounts] = useState({
        completed: 0,
        submitted: 0,
        rejected: 0,
        inProgress: 0
    });

    const [auth] = useAuth();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

    const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff8042", "#ffbb28", "#00C49F", "#FF8042"];

    // Handle screen resize for better responsiveness
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 640);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.get("https://api.makeeasydocuments.com/api/getAll/Form11");
                const applications = response.data.data || [];
                console.log(applications)
                if (auth?.user?._id) {
                    const filtered = applications.filter((item) => item.user === auth.user._id);
                    setFilteredApplications(filtered);
console.log("filter is ",filtered)
                    // Count different form statuses
                    const counts = {
                        completed: filtered.filter(app => app.Status === "Completed").length,
                        submitted: filtered.filter(app => app.Status === "Submitted").length,
                        rejected: filtered.filter(app => app.Status === "Rejected").length,
                        inProgress: filtered.filter(app => app.Status === "In-Progress").length
                    };
                    setStatusCounts(counts);

                    // // Count different form types dynamically
                    // const typeCounts = {};
                    // .forEach(app => {
                    //     typeCounts[app.formType] = (typeCounts[app.formType] || 0) + 1;
                    // });
                    // setFormTypesCount(typeCounts);

                    const formTypeCounts = {};
                    filtered.forEach((item) => {
          formTypeCounts[item.application_type] =
            (formTypeCounts[item.application_type] || 0) + 1;
        });
        setFormTypesCount(formTypeCounts)

                } else {
                    setError("User information is not available");
                }
            } catch (err) {
                setError("Failed to fetch applications");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [auth]);

    // Convert `formTypesCount` to data format for charts
    const chartData = Object.entries(formTypesCount).map(([type, count]) => ({
        name: type,
        value: count,
    }));

console.log("chart is ",chartData)
    return (
        <section className="flex flex-col mt-20">
            <p className="font-semibold text-2xl md:text-3xl text-center">Our Outstanding Achievements</p>
            <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-y-5 gap-x-5 place-items-center w-full mx-auto max-w-7xl px-5">

                {/* Completed Forms */}
                <div className="flex flex-col justify-center items-center hover:bg-[#65e23f] hover:text-white bg-[#95c088] px-4 h-[126px] w-full md:w-[281px] md:h-[192px] rounded-lg">
                    <p className="font-bold text-sm sm:text-4xl lg:text-5xl">{statusCounts.completed}</p>
                    <p className="font-medium text-base sm:text-lg mt-3 md:mt-6 text-center">Completed Forms</p>
                </div>

                {/* Submitted Forms */}
                <div className="flex flex-col justify-center items-center hover:bg-[#e241e2] hover:text-white bg-[#b46bb4] px-4 h-[126px] w-full md:w-[281px] md:h-[192px] rounded-lg">
                    <p className="font-bold text-3xl sm:text-4xl lg:text-5xl">{statusCounts.submitted}+</p>
                    <p className="font-medium text-base sm:text-lg mt-3 md:mt-6 text-center">Submitted Forms</p>
                </div>

                {/* Rejected Forms */}
                <div className="flex flex-col justify-center items-center hover:bg-[#e7ac3f] hover:text-white bg-[#d7bc89] px-4 h-[126px] w-full md:w-[281px] md:h-[192px] rounded-lg">
                    <p className="font-bold text-3xl sm:text-4xl lg:text-5xl">{statusCounts.rejected}+</p>
                    <p className="font-medium text-base sm:text-lg mt-3 md:mt-6 text-center">Rejected Forms</p>
                </div>

                {/* In Progress Forms */}
                <div className="flex flex-col justify-center items-center hover:bg-[#58141f] hover:text-white bg-[#eb8798] px-4 h-[126px] w-full md:w-[281px] md:h-[192px] rounded-lg">
                    <p className="font-bold text-3xl sm:text-4xl lg:text-5xl">{statusCounts.inProgress}+</p>
                    <p className="font-medium text-base sm:text-lg mt-3 md:mt-6 text-center">In Progress Forms</p>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-10">
                {/* Bar Chart */}
                <div className="bg-white rounded-xl shadow-lg p-4 h-[400px]">
                    <h3 className="text-lg md:text-xl font-semibold text-gray-700 mb-4">Forms Distribution</h3>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 50 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" angle={-45} textAnchor="end" height={60} interval={0} />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="value" fill="#4A90E2" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                {/* Pie Chart */}
                <div className="bg-white rounded-xl shadow-lg p-4 h-[400px]">
                    <h3 className="text-lg md:text-xl font-semibold text-gray-700 mb-4">Forms Overview</h3>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie data={chartData} cx="50%" cy="40%" outerRadius={isMobile ? 60 : 120} dataKey="value">
                                {chartData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend layout="horizontal" align="center" verticalAlign="bottom" />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </section>
    );
};

export default Carouseluser;
